import { Component } from '@angular/core';
import { BillingSubscriptionBodyComponent, BillingSubscriptionWinComponent } from 'sharedFeatures/billing';
import { SubscriptionCancelWinBodyComponent } from 'sharedFeatures/subscription-cancel-win';
import { WindowComponent } from "sharedFeatures/window";

@Component(
{
        selector: 'subscription-switch-win',
        templateUrl: '../window/window.component.html',
        styleUrls: ['../window/window.component.less']
})
export class SubscriptionCancelWinComponent extends WindowComponent {
    width = 475;
    height = 350;

    showClose = true;

    title = $localize`cancel_subscription`;

    cornerRadius = 9;

    modal = true;
    shadowStyle = 'drop-shadow';
    billingComponent: BillingSubscriptionBodyComponent | null = null;
    hostWindow: BillingSubscriptionWinComponent | null = null;

    topMargin = 30;

    windowContentBody = SubscriptionCancelWinBodyComponent;
    testId = "Subscription-cancel";

    getBodyComponent(): SubscriptionCancelWinBodyComponent {
        return <SubscriptionCancelWinBodyComponent>super.getBodyComponent();
    }

    //onClose() {
    //    this.hostWindow.setZIndex(PopupComponent.getTopestZ() + 1);
    //    this.close();
    //}

}